import axios from "axios";

export const URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/care-management/patient-programs";


export const searchPatientPrograms = (patientId) => {
    return axios
        .get(`${URL}?patientId=${patientId}`);
}